const getRepossessionRoute = () => {
	const repo = sessionStorage.getItem('repossessionRoute');
	if (repo) {
		return JSON.parse(repo);
	}
	return {};
};

const setRepossessionRoute = (repo: any) => {
	sessionStorage.setItem('repossessionRoute', JSON.stringify(repo));
};

const clearRepossessionRoute = () => {
	sessionStorage.removeItem('writerepossessionRouteOffrepo');
};
export { getRepossessionRoute, setRepossessionRoute, clearRepossessionRoute };
